import { defineComponent as _defineComponent } from 'vue'
import { SideSheet } from '@/modules/common/components/SideSheet';
import {
  BaseIcon,
  DataTable,
  DataTableProps,
  Heading
} from '@warrenbrasil/nebraska-web';
import { PropType } from 'vue';
import { ISummaryV2 } from '@/modules/cash/services/costs-v2';
import { MoneyCell } from '@/modules/common/components/MoneyCell';

export default /*#__PURE__*/_defineComponent({
  __name: 'CashbackSideSheet',
  props: {
  isOpen: Boolean,
  year: {
    type: String,
    default: ''
  },
  month: {
    type: Object as PropType<ISummaryV2>,
    default: {} as ISummaryV2
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props



const columns: DataTableProps.Column[] = [
  {
    label: 'Produto',
    type: 'chip',
    align: DataTableProps.Align.Left,
    getter: 'label'
  },
  {
    label: 'Valor do cashback',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: 'value'
  }
];



return { __sfc: true,props, columns, emit, SideSheet, BaseIcon, DataTable, Heading }
}

})